import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

//Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

//assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";

//Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DropDownBox from "Components/Common/DropDownBox";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";

//redux
import { useDispatch } from "react-redux";
import { addIndustryTraining, editIndustryTraining, fetchIndividualIndustryTraining, fetchIndustryTrainingCategory } from "../../../../Redux/Slices/contentManagementSlice";
import { uploadSingle } from "../../../../Redux/Slices/mainSlice";

const EditIndustryTraining = () => {
  const {id} = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedLearningType, setSelectedLearningType] = useState(null);
  const [selectedOption2, setSelectedOption2] = useState(null);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [learningTitle, setLearningTitle] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});


  const [category,setCategory] = useState([
    { value: "bearing1", label: "bearing 1" },
    { value: "bearing2", label: "bearing 2" },
    { value: "bearing3", label: "bearing 3" },
  ]);
  const [learningType,setLearningType] = useState([
    { value: 1, label: "READING AND WRITING" },
    { value: 2, label: "VISUAL" },
    { value: 3, label: "AUDITORY" },
    { value: 4, label: "KINESTHETIC" },
  ]);

  const handleDropDownChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setErrors({
      ...errors,
      category:''
    })
  };
  const handleDropDownChange1 = (selectedOption) => {
    setSelectedLearningType(selectedOption);
  };
  const handleDropDownChange2 = (selectedOption) => {
    setSelectedOption2(selectedOption);
    setErrors({
      ...errors,
      learningType:''
    })
  };

  const handleFileChange = (event) => {
    const formData = new FormData();
    formData.append("file",event.target.files[0])
    const uploadCB = (value)=>{
      // console.log(value)
      setFile(value.data.url)
      setErrors({
        ...errors,
        file:''
      })
    }
    dispatch(
      uploadSingle({
        data:formData,
        callBack:uploadCB,
      })
    )
  };

  const handleValidation = () => {
    let validationErrors = {};

    const industryNameErrors = validateInput("industryTrainingCategory", category);
    if (industryNameErrors.industryName) {
      validationErrors.industryName = industryNameErrors.industryName;
    }
  
    const learningTypeErrors = validateInput("industryTrainingLearningType", learningType);
    if (learningTypeErrors.learningType) {
      validationErrors.learningType = learningTypeErrors.learningType;
    }
  
    const learningTitleErrors = validateInput("learningTitle", learningTitle);
    if (learningTitleErrors.learningTitle) {
      validationErrors.learningTitle = learningTitleErrors.learningTitle;
    }
  
    // const descriptionErrors = validateInput("description", description);
    // if (descriptionErrors.description) {
    //   validationErrors.description = descriptionErrors.description;
    // }
  
    if (!file && !videoLink) {
      const fileErrors = validateInput("file", file);
      if (fileErrors.file) {
        validationErrors.file = fileErrors.file;
      }
  
      const videoLinkErrors = validateInput("videoLink", videoLink);
      if (videoLinkErrors.videoLink) {
        validationErrors.videoLink = videoLinkErrors.videoLink;
      }
    }
  
    setErrors(validationErrors);
    return validationErrors;

  }


  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {
    // Handle form submission logic here
    const data = {
      "category_name": selectedCategory?.industry_name,
      "category_id": selectedCategory?.industry_type_id,
      "learning_type": selectedLearningType?.value,
      "learning_title": learningTitle,
      "description": description,
      ...(file && { file_url: file }),
      ...(file && { file_type: file.split('.').pop() }),
      "content_link": videoLink
    }
    console.log(data);
    const editIndustryCB = (value) => {
      setIsSuccess(true)
    }
    dispatch(
      editIndustryTraining({
        id,
        data:data,
        callBack:editIndustryCB
      })
    ) 
  }
  };

  useEffect(() => {
    // Fetch categories first, then fetch product details
    dispatch(
      fetchIndustryTrainingCategory({
        callBack: getCategoryCB,
      })
    );
  }, [dispatch]);
  
  useEffect(() => {    
    // Fetch individual product training details only after the categories are loaded
    if (category.length > 0) {
      dispatch(
        fetchIndividualIndustryTraining({
          data: { id },
          callBack: getExistingCB,
        })
      );
    }
  }, [category, dispatch, id]);

  // useEffect
  

  const  getExistingCB = (value) =>{
    // console.log(value.result)
    setLearningTitle(value.result.learning_title)
    setDescription(value.result.description)
    setVideoLink(value.result.content_link)
    setFile(value.result.file_url)
    const matchingCategory = category.find(
      (item) => item.industry_type_id === value.result.category_id
    );  
    if (matchingCategory) {
      handleDropDownChange(matchingCategory);
    }
    const matchingLearningType = learningType.find(
      (item) => item.value === value.result.learning_type
    );
    if(matchingLearningType){
      setSelectedLearningType(matchingLearningType)
    }
  }

  const getCategoryCB = (value) => {
    // console.log(value)
    //add laabel and value for dropdown options
    const updatedCategories = value.data.map(item => ({
      ...item,
      label: item?.industry_name,
      value: item?.industry_type_id
    }));
    setCategory(updatedCategories)
  }

  return (
    <MainLayout pageName={"Content Management"}>
      {/* SuccessCard - Conditionally render */}
      {isSuccess && (
        <SuccessCard 
        title="Industry Training Edited Successfully"
        subTitle="Industry Training Details Edited Successfully."
        onClose={() => setIsSuccess(false)} // Close the SuccessCard
        onGoBack={() => navigate(-1)} // Navigate back
      />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Industry Training List</p>
      </div>
      <form className="AddIndustryTrainingContainer" onSubmit={handleSubmit}>
        {/* Header */}
        <div className="AddIndustryTrainingContainerHeader">
          <h2>Edit Industry Training Details</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6" }} />
        <div className="AddIndustryTrainingInputBoxBody">
          <div className="AddIndustryTrainingInputContainer">
            <p>Category</p>
            <div className="AddIndustryTrainingInputBoxContainer">
              <DropDownBox
                options={category}
                placeholder="Steel"
                onChange={handleDropDownChange}
                value={selectedCategory}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #B2BEC3",
                    boxShadow: "none",
                    padding: "5px 3px",
                    fontFamily: "Poppins",
                    fontSize: "2.2vh",
                    marginRight: "10px",
                    height: "7vh",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    color: '#697077',
                  }),
                  option: (provided) => ({
                    ...provided,
                    color: '#697077',
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: 'black',
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                }}
              />
              {errors.category && <ErrorMessage message={errors.category} />}
            </div>
          </div>
          <div className="AddIndustryTrainingInputContainer">
            <p>Learning Type</p>
            <div className="AddIndustryTrainingInputBoxContainer">
              <DropDownBox
                options={learningType}
                placeholder="PDF"
                onChange={handleDropDownChange1}
                value={selectedLearningType}
                customStyles={{
                  control: (provided) => ({
                    ...provided,
                    border: "1px solid #B2BEC3",
                    boxShadow: "none",
                    padding: "5px 3px",
                    fontFamily: "Poppins",
                    fontSize: "2.2vh",
                    marginRight: "10px",
                    height: "7vh",
                  }),
                  menu: (provided) => ({
                    ...provided,
                    color: '#697077',
                  }),
                  option: (provided) => ({
                    ...provided,
                    color: '#697077',
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: 'black',
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                }}
              />
              {errors.learningType && <ErrorMessage message={errors.learningType} />} 
            </div>
          </div>
          <div className="AddIndustryTrainingInputContainer">
            <p>Learning Title</p>
            <div className="AddIndustryTrainingInputBoxContainer">
              <InputBox
                inputStyle={{
                  boxShadow:'none',
                  border: "1px solid #B2BEC3",
                  padding: "1px 1vh 1px 2vh",
                  height: "6.5vh",
                  fontSize: "2.2vh",
                  width: '32.3vw',
                  color: "black"
                }}
                name="learningTitle"
                value={learningTitle}
                onChange={(e) => {setLearningTitle(e.target.value);
                  setErrors({
                    ...errors,
                    learningTitle:''
                  })
                }}              />
             {errors.learningTitle && <ErrorMessage message={errors.learningTitle} />}
            </div>
          </div>
        </div>
        <div className="AddIndustryTrainingTextContainer">
          <p>Description</p>
          <div className="AddIndustryTrainingInputBoxContainer">
            <textarea
              value={description}
              onChange={(e) => {setDescription(e.target.value);
                setErrors({
                  ...errors,
                  description:''
                })
              }}              rows="5"
              placeholder="Enter description here"
              className="textAreaInput"
            />
            {errors.description && <ErrorMessage message={errors.description} />} 
          </div>
        </div>

        <div className="AddIndustryTrainingTextContainer">
          <p style={{marginBottom:'20px',marginTop:'10px'}}>Upload File</p>
          <div className="fileUploadContainer">
            <label htmlFor="uploadFile" className="uploadFileLabel">
              Upload
              <input
                type="file"
                id="uploadFile"
                accept=".pdf,.mp4,.mov,.mpeg,.webm,.mkv"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </label>
            {errors.file && <div style={{marginTop:'1rem'}}> <ErrorMessage message={errors.file}  /> </div>}
          </div>
        </div>
        {file ? (
          <p style={{ marginTop: "1rem" }}>{file.split("---").pop()}
          {file ? (
                    <span
                      style={{
                        color: "red",
                        marginLeft: "10px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setFile("")}
                    >
                      X
                    </span>
                  ) : (
                    ""
                  )}
          </p>
        ) : (
          ""
        )}
        <p style={{marginTop:'20px', color:'#7A7A7A', fontSize:'2vh'}}>OR</p>

        <div className="AddIndustryTrainingTextContainer">
          <p>Video Link</p>
          <div className="AddIndustryTrainingInputBoxContainer">
            <InputBox
              inputStyle={{
                border: "1px solid #B2BEC3",
                padding: "1px 2vh 1px 2vh",
                fontSize: "2.2vh",
                height: "7vh",
                boxShadow:'none',
                color: "black"
              }}
              name="videoLink"
              value={videoLink}
              onChange={(e) => {setVideoLink(e.target.value);
                setErrors({
                  ...errors,
                  videoLink:''
                })
              }}            />
             {errors.videoLink && <ErrorMessage message={errors.videoLink} />}
          </div>
        </div>

        <div className="addIndustryTrainingButtons">
          <div className="addIndustryTrainingButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addIndustryTrainingButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Save"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default EditIndustryTraining;
